import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Autocomplete,
  Typography,
  FormControl,
  Menu,
  MenuItem,
} from "@mui/material";
import styles from "../PieChart.module.scss";
import {
  convertDateYYYYMMDD,
  decryptedAdminID,
  MyModal,
} from "../../../utility";
import ModalContainer from "../../../components/modal_popup";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
  JobsDashboardFilterActions,
  CandidateDashboardFilterActions,
} from "../../../redux-store/store";
import { getJobFilterOptions } from "../../../apiServices";

const AdminTableFilter = () => {
  const JobsFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard
  );

  const dispatch = useDispatch();
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const initialObject = {
    adminId: isSuperAdmin ? -1 : decryptedAdminID(),
    startDate: JobsFilter.startDate,
    endDate: JobsFilter.endDate,
  };

  const [jobOpen, setJobOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState(initialObject);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [options, setOptions] = useState({ city: "" });
  const [showCustom, setShowCustom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dateRange, setDateRange] = useState({
    start: JobsFilter.startDate,
    end: JobsFilter.endDate,
    dateFilterType: JobsFilter.dateFilterType,
  });
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });

  useEffect(() => {
    console.log(filters, "good");
  }, []);
  useEffect(() => {
    getJobFilterOptions().then((data) => {
      const cityOptions = data.filter((element) => element.category === "city");
      setOptions((prev) => ({
        ...prev,
        city: cityOptions,
      }));
    });
  }, []);

  const handleJobClose = () => {
    setIsFilterOpen(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleClearAll = () => {
    setFilters({
      adminId: isSuperAdmin ? -1 : decryptedAdminID(),
    });
    setDateRange({
      start: null,
      end: null,
      dateFilterType: "",
    });

    dispatch(
      CandidateDashboardFilterActions.setCandidateFilter({
        ...initialObject,
        startDate: "2024-06-01",
        endDate: convertDateYYYYMMDD(new Date()),
      })
    );
    setSelectedFilters(null);
  };

  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "currentMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 2);
      endDate = today;
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "lastMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 2);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: convertDateYYYYMMDD(endDate),
      }));
    } else if (val === "last 3 Months") {
      // Get the current date
      const today = new Date();

      // Calculate the start date as 3 months ago from today
      const startDate = new Date(today);
      startDate.setMonth(today.getMonth() - 2); // Subtract 3 months

      // Adjust the start date to the 1st of the month (dynamic adjustment)
      startDate.setDate(1); // Set it to the 1st of that month

      // Set the end date to today's date
      const endDate = today;

      // Set the date range
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "last 3 Months",
        start: startDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
        end: convertDateYYYYMMDD(endDate), // Assuming this function formats the date correctly
      }));
    } else if (val === "last 6 Months") {
      // Get the current date
      const today = new Date();

      // Calculate the start date as 6 months ago from today
      const startDate = new Date(today);
      startDate.setMonth(today.getMonth() - 5); // Subtract 5 months (to include the last 6 months)

      // Adjust the start date to the 1st of the month (dynamic adjustment)
      startDate.setDate(1); // Set it to the 1st of that month

      // Set the end date to today's date
      const endDate = today;

      // Set the date range
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "last 6 Months",
        start: startDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
        end: convertDateYYYYMMDD(endDate), // Assuming this function formats the date correctly
      }));
    } else if (val === "last 12 Months") {
      // Get the current date
      const today = new Date();

      // Calculate the start date as 12 months ago from today
      const startDate = new Date(today);
      startDate.setMonth(today.getMonth() - 11); // Subtract 11 months (to include the last 12 months)

      // Adjust the start date to the 1st of the month (dynamic adjustment)
      startDate.setDate(1); // Set it to the 1st of that month

      // Set the end date to today's date
      const endDate = today;

      // Set the date range
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "last 12 Months",
        start: startDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
        end: convertDateYYYYMMDD(endDate), // Assuming this function formats the date correctly
      }));
    } else if (val === "custom") {
      setShowCustom(true);
    }

    setAnchorEl(null);
  };

  const handleCustomDate = (value, type) => {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  };

  const isFormValid = () => {
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApply = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      setValidationErrors({
        start: false,
        end: false,
      });
      setShowCustom(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      CandidateDashboardFilterActions.setCandidateFilter({
        ...filters,
        startDate: dateRange.start || JobsFilter.startDate,
        endDate: dateRange.end || JobsFilter.endDate,
        dateFilterType: dateRange.dateFilterType || "",
      })
    );
    console.log("Filter Data to be dispatched:", filters);

    setSelectedFilters(filters);
    handleJobClose();
    setIsFilterOpen(false); // Close the popup when submit is clicked
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault(); // Prevent form submission from refreshing the page

  //     // Prepare the filter data to dispatch
  //     const filterData = {
  //       ...filters,
  //       startDate: dateRange.start || JobsFilter.startDate,
  //       endDate: dateRange.end || JobsFilter.endDate,
  //       dateFilterType: dateRange.dateFilterType || "", // Use empty string if no value
  //     };

  //     // Log the filter data before dispatching
  //     console.log("Filter Data to be dispatched:", filterData);

  //     // Dispatch action to update the filter in the state
  //     dispatch(CandidateDashboardFilterActions.setCandidateFilter(filterData));

  //     // Log the updated selected filters
  //     console.log("Selected Filters:", filters);

  //     // Close the job filter popup
  //     handleJobClose();
  //     console.log("Job filter popup closed");

  //     // Close the filter popup
  //     setIsFilterOpen(false);
  //     console.log("Filter popup closed");
  //   };

  return (
    <div className={styles.filterContainer}>
      <div>
        <button
          className="btn btn-success"
          onClick={() => setIsFilterOpen(true)}
        >
          Filter
        </button>
      </div>
      {isFilterOpen && (
        <MyModal>
          <ModalContainer
            zIndex={1005}
            childComponent={
              <div style={{ width: 400 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <Typography variant="h6" gutterBottom>
                    <b>Filter</b>
                  </Typography>
                  <div>
                    <button className="btn btn-danger" onClick={handleJobClose}>
                      <AiOutlineClose />
                    </button>
                  </div>
                </div>
                <FormControl variant="outlined" fullWidth>
                  <TextField
                    label="Created on"
                    value={dateRange.dateFilterType}
                    aria-controls={anchorEl ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={anchorEl ? "true" : undefined}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    className="mt-2"
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => handleDateSelect("currentMonth")}>
                      Current Month
                    </MenuItem>
                    <MenuItem onClick={() => handleDateSelect("lastMonth")}>
                      Last Month
                    </MenuItem>
                    <MenuItem onClick={() => handleDateSelect("last 3 Months")}>
                      last 3 Months
                    </MenuItem>
                    <MenuItem onClick={() => handleDateSelect("last 6 Months")}>
                      last 6 Months
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleDateSelect("last 12 Months")}
                    >
                      last 12 Months
                    </MenuItem>
                    <MenuItem onClick={() => handleDateSelect("custom")}>
                      Custom Date/Month
                    </MenuItem>
                  </Menu>
                </FormControl>
                {showCustom && (
                  <MyModal>
                    <ModalContainer
                      zIndex={1005}
                      childComponent={
                        <div style={{ minWidth: "600px", width: "auto" }}>
                          <form onSubmit={handleApply}>
                            <p className="text-center">Select Custom Date</p>
                            <div className="mt-2">
                              <label htmlFor="start">From</label>
                              <input
                                className={`form-control ${
                                  validationErrors.start ? "is-invalid" : ""
                                }`}
                                type="date"
                                id="start"
                                onChange={(value) =>
                                  handleCustomDate(value, "startDate")
                                }
                                min="2020-01-01"
                                max={new Date().toISOString().split("T")[0]}
                              />
                              {validationErrors.start && (
                                <div className="invalid-feedback">
                                  Start date is required.
                                </div>
                              )}
                            </div>
                            <div className="mt-2">
                              <label htmlFor="end">To</label>
                              <input
                                className={`form-control ${
                                  validationErrors.end ? "is-invalid" : ""
                                }`}
                                type="date"
                                id="end"
                                onChange={(value) =>
                                  handleCustomDate(value, "endDate")
                                }
                                min="2020-01-01"
                                max={new Date().toISOString().split("T")[0]}
                              />
                              {validationErrors.end && (
                                <div className="invalid-feedback">
                                  End date is required.
                                </div>
                              )}
                            </div>
                            <div className="d-flex justify-content-end mt-3 ">
                              <button
                                onClick={() => {
                                  setValidationErrors({
                                    start: false,
                                    end: false,
                                  });
                                  setShowCustom(false);
                                }}
                                style={{
                                  backgroundColor: "#b2261c",
                                }}
                                className="btn rounded-pill text-white px-4  me-2"
                              >
                                Close
                              </button>
                              <button
                                onClick={handleApply}
                                // color="primary"
                                className="btn rounded-pill text-white px-4"
                                style={{
                                  backgroundColor: "#169C50",
                                }}
                              >
                                Apply
                              </button>
                            </div>
                          </form>
                        </div>
                      }
                    />
                  </MyModal>
                )}
                <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleClearAll}
                    sx={{ mt: 2 }}
                  >
                    Clear All
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success"
                    sx={{ mt: 2, mr: 1 }}
                    onClick={handleSubmit}
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}
    </div>
  );
};

export default AdminTableFilter;
